/**
 * create-training-steps.js
 */

import React from 'react';
import TourStep from '../tour-step';
import tourStepProps from '../tour-step-props';


export default [
  {
    target: "[data-testid='drawer-header-title']",
    title: "Introduction",
    ...tourStepProps,
    placementBeacon: "right",
    styles: {
      spotlight: {
        display: 'none',
      },
    },
    content: (
      <TourStep>
        This tour provides an overview of the event editor.
        Events define who will be training when and where.
        Each event may include one of more exercises.
      </TourStep>
    ),
  },
  {
    target: "[data-testtype='drawer-menu']",
    title: "Events and Exercises",
    ...tourStepProps,
    content: (
      <TourStep>
        Your training record will include information on the event and any exercises that you perform.
        Use this section to navigate between the options.
        The event option is selected because you're currently editing the event.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='event-editor-form']",
    title: "Event Form",
    ...tourStepProps,
    placement: "left-start",
    spotlightClicks: true,
    content: (
      <TourStep>
        This is the form where you'll record information about the event.
        Notice as you hover your mouse over various parts of the form that help information pops up in the lower left of the <strong>Record Editor</strong>.
        If you're ever confused about a form field then review this information for guidance.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='event-editor-form']",
    title: "Expandable Sections",
    ...tourStepProps,
    placement: "left-end",
    spotlightClicks: true,
    content: (
      <TourStep>
        See the arrows pointing down on the far right of the form?
        They show areas that you can expand to reveal additional fields.
        Try clicking one of the arrows now and then click it again to hide the fields.
      </TourStep>
    ),
  },
];
